"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0642 22C12.2521 21.9982 12.4315 21.9208 12.5618 21.7854L15.5043 18.7278C15.7724 18.4493 15.7639 18.0062 15.4854 17.7381C15.2068 17.47 14.7637 17.4785 14.4956 17.7571L12.7574 19.5631V13.1658C12.7574 12.7792 12.444 12.4658 12.0574 12.4658C11.6708 12.4658 11.3574 12.7792 11.3574 13.1658V19.61L9.49494 17.7475C9.22157 17.4741 8.77836 17.4741 8.50499 17.7475C8.23162 18.0208 8.23161 18.464 8.50498 18.7374L11.5625 21.795C11.6954 21.9279 11.8762 22.0018 12.0642 22Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 8.74999C21 6.70653 19.3435 5.04999 17.3 5.04999L6.7 5.04999C4.65655 5.04999 3 6.70653 3 8.74999L3 15.95C3 17.6069 4.34313 18.95 5.99995 18.95V17.55C5.11632 17.55 4.4 16.8337 4.4 15.95L4.4 8.74999C4.4 7.47973 5.42975 6.44999 6.7 6.44999L17.3 6.44999C18.5703 6.44999 19.6 7.47973 19.6 8.74999V15.9499C19.6 16.8336 18.8836 17.55 18 17.55C17.6134 17.55 17.3 17.8634 17.3 18.25C17.3 18.6366 17.6134 18.95 18 18.95C19.6568 18.95 21 17.6068 21 15.9499V8.74999Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.04995 18.25C5.04995 18.6366 5.36335 18.95 5.74995 18.95L5.99995 18.95C6.38655 18.95 6.69995 18.6366 6.69995 18.25C6.69995 17.8634 6.38655 17.55 5.99995 17.55L5.74995 17.55C5.36335 17.55 5.04995 17.8634 5.04995 18.25Z",
  fill: "currentColor"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CardMoveDown24.js.map